<template>
  <v-app>
    <v-container fluid>
      <v-row v-if="$insertAccess($route.path)">
        <v-col cols="12">
          <BaseCard
            title="Direct Receive Entry"
            icon="mdi-truck-delivery"
            vCardTextClass="pa-2"
          >
            <v-form @submit.prevent="submit" ref="addEmployee" id="addEmployee">
              <v-row>
                <v-col md="3" cols="12">
                  <v-card elevation="0" border rounded="lg" class="pa-2 h-100">
                    <div class="d-flex align-center mb-4">
                      <v-avatar color="primary" variant="tonal" size="36" class="me-2">
                        <v-icon size="20">mdi-information-outline</v-icon>
                      </v-avatar>
                      <div>
                        <div class="text-subtitle-1 font-weight-medium">Main details</div>
                        <div class="text-caption text-medium-emphasis">Provide main information</div>
                      </div>
                    </div>
                    <v-row dense>
                      <v-col cols="12">
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="warehouse_id.value.value"
                        :items="getWarehouseList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :menu-props="{ contentClass: 'my-custom-dropdown' }"
                        :error-messages="warehouse_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Warehouse <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="purpose_id.value.value"
                        :items="getPurposeList"
                        :item-title="(item) => `${item.name}`"
                        :menu-props="{ contentClass: 'my-custom-dropdown' }"
                        item-value="id"
                        :error-messages="purpose_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Purpose/Project <span class="text-red-accent-4"></span>
                        </template>
                      </v-autocomplete>
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="supplier_id.value.value"
                        :items="getSupplierList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :menu-props="{ contentClass: 'my-custom-dropdown' }"
                        :error-messages="supplier_id.errorMessage.value"
                        autocomplete="off"
                        @update:model-value="onSupplierChange"
                        clearable
                      >
                        <template #label>
                          Supplier Name
                        </template>
                      </v-autocomplete>
                        <v-date-input
                          input-format="dd/mm/yyyy"
                          density="compact"
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="receive_date.value.value"
                          :error-messages="receive_date.errorMessage.value"
                          autocomplete="off"
                          clearable
                        >
                          <template #label>
                            Receive Date <span class="text-red-accent-4">*</span>
                          </template>
                        </v-date-input>
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="Source Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="shipping_date.value.value"
                        :error-messages="shipping_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                      <v-textarea
                        label="Source Address"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="shipping_address.value.value"
                        :error-messages="shipping_address.errorMessage.value"
                        autocomplete="off"
                        rows="1"
                        clearable
                      ></v-textarea>
                      <v-text-field
                        label="Receive By"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="receive_by.value.value"
                        :error-messages="receive_by.errorMessage.value"
                        autocomplete="off"
                        :disabled="true"
                        clearable
                      ></v-text-field>
                      <v-text-field
                        label="receive By Mobile"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="receive_by_mobile.value.value"
                        :error-messages="receive_by.errorMessage.value"
                        autocomplete="off"
                        :disabled="true"
                        clearable
                      ></v-text-field>
                      <v-text-field
                        label="receive By Email"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="receive_by_email.value.value"
                        :error-messages="receive_by_email.errorMessage.value"
                        :disabled="true"
                        autocomplete="off"
                        clearable
                      ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col class="pl-0" md="9" cols="12">
                  <v-card elevation="0" border rounded="lg">
                    <div class="d-flex align-center pt-4 px-4">
                      <v-avatar color="primary" variant="tonal" size="36" class="me-2">
                        <v-icon size="20">mdi-format-list-bulleted</v-icon>
                      </v-avatar>
                      <div>
                        <div class="text-subtitle-1 font-weight-medium">Receive items</div>
                        <div class="text-caption text-medium-emphasis">
                          Search and add products to this receipt
                        </div>
                      </div>
                    </div>
                    <v-row class="px-4 mt-2" justify="center">
                    <v-col cols="12" md="9" lg="8">
                      <v-autocomplete
                        label="Search Product Name"
                        variant="outlined"
                        density="compact"
                        :menu-props="{ contentClass: 'my-custom-dropdown' }"
                        bg-color="grey-lighten-4"
                        v-model="product_id.value.value"
                        :items="getProductMapList"
                        :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'"
                        item-value="product_id"
                        :error-messages="product_id.errorMessage.value"
                        @update:model-value="addCart"
                        @keydown.enter="addCart"
                        autocomplete="off"
                        hide-details="auto"
                        clearable
                      ></v-autocomplete>

                      <input
                        v-model="receive_masters_id.value.value"
                        type="hidden"
                      />
                    </v-col>

                  </v-row>

                  <!-- Cart Table -->
                  <v-row>
                    <v-col cols="12">
                      <v-card elevation="0" class="overflow-x-auto">
                      <v-table
                        density="compact"
                        :loading="loading"
                        fixed-header
                        style="max-height: 600px ; overflow-y: scroll"
                      >
                        <thead>
                          <tr>
                            <th class="text-center">SL</th>
                            <th class="text-left" style="width: 15%">Code</th>
                            <th class="text-left" style="width: 15%">Product Name</th>
                            <th class="text-center" style="width: 15%">Unit</th>
                            <th class="text-center" style="width: 15%">Lot No.</th>
                            <th class="text-center" style="width: 15%">Expiry Date</th>
                            <th class="text-center" style="width: 15%">Quantity</th>
                            <th style="width: 15%">Pur. Rate</th>
                            <th style="width: 15%">Sales Rate</th>
                            <th class="text-right" style="min-width:70px">Sub Total</th>
                            <th class="text-left" style="min-width:130px">Standard Purity (%)</th>
                            <th class="text-left" style="min-width:130px">Present Purity (%)</th>
                            <th class="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in cart"
                            v-if="cart.length > 0"
                            :key="index"
                          >
                            <td class="text-center">{{ index + 1 }}</td>
                            <td
                              class="text-left px-1"
                              style="white-space: normal"
                            >
                              {{ item.code }}
                            </td>
                            <td
                              class="text-left px-1"
                            >
                              {{ item.product_name }}
                            </td>
                              <td class="text-center px-1">
                              {{ item.unit_name }}
                            </td>
                             <td class="text-right px-1">
                              <v-text-field
                                :inset="true"
                                density="compact"
                                variant="outlined"
                                style="width: 100px"
                                bg-color="grey-lighten-4"
                                v-model="item.lot_no"
                                hide-details="auto"
                              ></v-text-field>
                            </td>
                             <td class="text-right px-1">
                               <v-date-input
                                 input-format="dd/mm/yyyy"
                                 label="dd/mm/yyyy"
                                 density="compact"
                                 style="width: 120px"
                                 prepend-icon=""
                                 hide-details="auto"
                                 variant="outlined"
                                 bg-color="grey-lighten-4"
                                 v-model="item.expiry_date"
                                 autocomplete="off"
                                 clearable
                               ></v-date-input>
                            </td>
                            <td class="text-right px-1">
                              <v-text-field
                                :reverse="false"
                                controlVariant="stacked"
                                label=""
                                type="number"
                                style="width: 80px"
                                :hideInput="false"
                                :inset="false"
                                :min="1"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="item.qty"
                                hide-details="auto"
                                :error-messages="item.qty < 1? 'Quantity must be greater than 0': ''"
                                @update:model-value="item.total = item.qty * item.rate"
                                @blur="item.total = item.qty * item.rate"
                              ></v-text-field>
                            </td>
                          
                            <td class="text-right px-1">

                              <v-text-field
                                :reverse="false"
                                controlVariant="stacked"
                                label=""
                                :hideInput="false"
                                :inset="false"
                                :min="1"
                                type="number"
                                style="width: 120px"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="item.rate"
                                hide-details="auto"
                                :error="item.rate < 1"
                                :error-messages=" item.qty < 1 ? 'rate must be greater than 0' : '' "
                                @update:model-value=" item.total = item.qty * item.rate "
                              ></v-text-field>
                            </td>
                            <td class="text-right px-1">
                              <v-text-field
                                :reverse="false"
                                controlVariant="stacked"
                                label=""
                                type="text"
                                :hideInput="false"
                                :inset="false"
                                style="width: 120px"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="item.sales_rate"
                                hide-details="auto"
                              ></v-text-field>
                            </td>
                            <td class="text-right px-1">
                              {{ this.$numberFormat(item.total) }}
                            </td>
                            <td
                                class="text-end px-1"
                            >
                              {{ item.standard_purity }}
                            </td>
                            <td class="text-right px-1">
                              <v-text-field
                                  density="compact"
                                  variant="outlined"
                                  bg-color="grey-lighten-4"
                                  hide-details="auto"
                                  v-model="item.present_purity"
                                  @update:model-value="clampPurity(item)"
                              ></v-text-field>
                            </td>

                            <td class="text-center px-1">
                              <v-btn
                                icon="mdi-delete-outline"
                                size="small"
                                color="error"
                                variant="text"
                                @click="removeFromCart(index)"
                              ></v-btn>
                            </td>
                          </tr>
                          <tr v-else>
                            <td colspan="13" class="text-center py-8">
                              <v-icon size="32" color="primary" class="mb-2">
                                mdi-package-variant-closed
                              </v-icon>
                              <div class="text-body-2 text-medium-emphasis">
                                No items added yet
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                      </v-card>
                    </v-col>
                  </v-row>
                  <!-- Close Cart Table -->


                  </v-card>
                </v-col>
              </v-row>
            </v-form>

            <v-divider class="mt-2"></v-divider>
            <v-card-actions >
              <v-row align="start">
                <v-col cols="12" md="8">
                  <v-textarea
                      label="Remarks"
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      v-model="remarks.value.value"
                      :error-messages="remarks.errorMessage.value"
                      autocomplete="off"
                      rows="3"
                      clearable
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="d-flex justify-end ga-2">
                    <v-btn
                        color="grey-darken-1"
                        variant="flat"
                        prepend-icon="mdi-content-save-outline"
                        @click="submitForm(0)"
                    >
                      draft
                    </v-btn>
                    <v-btn
                        color="primary"
                        variant="flat"
                        prepend-icon="mdi-send-outline"
                        @click="submitForm(1)"
                    >
                      Post
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-actions>
          </BaseCard>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import {useStore} from "vuex";
import {useField, useForm} from "vee-validate";
import * as yup from "yup";
import {ref} from "vue";
import {toast} from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import {useRouter} from "vue-router";
import BaseCard from "@/components/utils/baseCard.vue";

export default {
  components: {
    BaseCard,
  },
  data: () => ({
    loading: false,
    errorMessages: "",
    visible: false,
    search: "",
    selectedImage: null,
    photo_imageFile: "",
    preview: "/src/assets/no_preview.png",
    cart: [],
  }),
  watch: {},
  created() {
    // if (this.$store.getters.getSupplierList.length === 0) {
    this.$store.dispatch("getSupplierList");
    // }
    // if (this.$store.getters.getWarehouseList.length === 0) {
    this.$store.dispatch("getWarehouseList");
    // }
    // if (this.$store.getters.getPurposeList.length === 0) {
    this.$store.dispatch("getPurposeList");
    // }
    // if (this.$store.getters.getProductMapList.length === 0) {
    this.$store.dispatch("getProductMapList");
    // }
  },
  computed: {
    getSupplierList() {
      return this.$store.getters.getSupplierList;
    },
    getWarehouseList() {
      return this.$store.getters.getWarehouseList;
    },
    getPurposeList() {
      return this.$store.getters.getPurposeList;
    },
    getProductMapList() {
      let products = this.$store.getters.getProductMapList;
      return products.filter(
          (item) => item.branch_id == this.$store.getters.getAuthUser.branch_id && item.status == 1
      );
    },
  },
  methods: {
    formattedDate,
    onSupplierChange(id) {
      if (!id) {
        return;
      } else {
        this.$store.dispatch("getSupplierById", id).then((res) => {

          this.shipping_address.value.value = res.supplier_address;
        });

      }
    },
    addCart() {
      let cartInd = this.cart.findIndex(
          (p) => p.product_id == this.product_id.value.value
      );
      if (this.product_id.value.value == null) {
        toast.error("Please select a Product");
        this.cartReset();
        return false;
      }
      if (cartInd > -1) {
        toast.error("Product already added in cart");
        this.cartReset();
        return false;
      }

      let product = this.getProductMapList.find(
          (item) => item.product_id == this.product_id.value.value
      );
      product = product.product;
      let item = {
        product_id: this.product_id.value.value,
        code: product.code,
        product_name: product.name,
        standard_purity: product.standard_purity || 0,
        present_purity: product.standard_purity || 0,
        lot_no: null,
        expiry_date: null,
        qty: 1,
        unit_id: product.unit_id,
        unit_name: product.unit.name,
        rate: product.purchase_rate,
        sales_rate: product.sale_rate,
        total: product.purchase_rate,
      };

      this.cart.push(item);
      this.$nextTick(() => {
        this.cartReset();
      });
    },
    removeFromCart(index) {
      if (confirm("Are You Sure?")) {
        this.cart.splice(index, 1);
      }
    },
    cartReset() {
      this.product_id.value.value = null;
    },
    clampPurity(item) {

      if (Number.isNaN(item.present_purity) || item.present_purity < 0) {
        item.present_purity = 0;
      } else if (item.present_purity > 100) {
        item.present_purity = 100;
      } else {
        item.present_purity = item.present_purity;
      }
    },
  },
  setup() {
    const {handleSubmit, resetForm} = useForm({
      validationSchema: yup.object({
        receive_date: yup.date().required().label("Receive Date"),
        shipping_date: yup.date().nullable().label("Shipping Date"),

        warehouse_id: yup
            .number()
            .positive()
            .integer()
            .required()
            .label("Designation Name"),
      }),
    });

    const shipping_date = useField("shipping_date");
    const product_id = useField("product_id");
    const status = useField("status");
    const employee_id = useField("employee_id");
    const supplier_id = useField("supplier_id");
    const warehouse_id = useField("warehouse_id");
    const purpose_id = useField("purpose_id");

    const receive_masters_id = useField("receive_masters_id");
    const receive_date = useField("receive_date");
    const remarks = useField("remarks");
    const receive_by = useField("receive_by");
    const receive_by_mobile = useField("receive_by_mobile");
    const receive_by_email = useField("receive_by_email");
    const shipping_address = useField("shipping_address");
    const errorMessages = ref("");
    const cart = ref([]);
    const loading = ref("");
    const buttonText = ref("");
    buttonText.value = "Save";
    const store = useStore();
    const router = useRouter();

    const currentStatus = ref(0);

    const submitForm = (status) => {
      currentStatus.value = status;
      submit();
    };

    const submit = handleSubmit((values) => {
      values.status = currentStatus.value;
      values.cart = cart.value;
      values.receive_date = formattedDate(receive_date.value.value);
      values.shipping_date = formattedDate(shipping_date.value.value);

      values.cart = cart.value.map((item) => ({
        ...item,
        expiry_date: formattedDate(item.expiry_date)
      }));

      store
          .dispatch("saveUpdateInvDirectReceive", values)
          .then((response) => {
            resetForm();
            buttonText.value = "Save";
            cart.value = [];
            toast.success(response.data.message, {
              timeout: 3000,
            });
            setTimeout(() => {
              router.push({name: "direct-receive-records"});
            }, 2000);
          })
          .catch((error) => {
            toast.error(error.response.data.message);
          });
    });

    return {
      submit,
      submitForm,
      product_id,
      receive_date,
      shipping_date,
      remarks,
      cart,
      shipping_address,
      receive_by,
      receive_by_mobile,
      receive_by_email,
      status,
      errorMessages,
      employee_id,
      supplier_id,
      warehouse_id,
      purpose_id,
      receive_masters_id,
      buttonText,
      loading,
    };
  },

  mounted() {
    this.status.value.value = 1;
    this.employee_id.value.value = "";
    let user = this.$store.getters.getAuthUser;
    this.receive_by.value.value = user.full_name;
    this.receive_by_mobile.value.value = user.mobile;
    this.receive_by_email.value.value = user.email;

    const id = this.$route.query.id;
    if (id) {
      this.$store.commit("SET_LOADING", {color: "primary"});

      this.$nextTick(() => {
        this.$store
            .dispatch("getInvDirectReceiveById", id)
            .then((data) => {
              this.isEntryMode = false;
              let receive = data;
              this.receive_masters_id.value.value = receive.id;
              this.receive_date.value.value = receive.receive_date
                  ? new Date(receive.receive_date)
                  : new Date();
              this.shipping_date.value.value = receive.shipping_date
                  ? new Date(receive.shipping_date)
                  : new Date();
              this.warehouse_id.value.value = receive?.warehouse?.id;
              this.purpose_id.value.value = receive?.purpose_id || null;
              this.supplier_id.value.value = receive?.supplier?.id;
              this.shipping_address.value.value = receive.shipping_address || "";
              this.product_id.value.value = null;
              this.cart.value = [];

              // Insert items one by one
              (receive.inv_dr_receive_details || []).forEach((item) => {
                this.cart.push({
                  product_id: item.product_id,
                  code: item.product?.code || "",
                  product_name: item.product?.name || "",
                  lot_no: item.lot_no,
                  expiry_date: item.expiry_date || null,
                  qty: item.qty,
                  unit_id: item.product.unit?.id || "",
                  unit_name: item.product.unit?.name || "",
                  rate: item.rate,
                  standard_purity: item.product?.standard_purity || 0,
                  present_purity: item.present_purity || 0,
                  sales_rate: item.sales_rate,
                  total: item.qty * item.rate,
                });
              });
              this.remarks.value.value = receive.remarks ? receive.remarks : "";
              this.$store.commit("UNSET_LOADING");
            })
            .catch((error) => {
              this.$store.commit("UNSET_LOADING");
              console.error("Failed to fetch receive:", error);
            });
      });
    } else {
      this.receive_masters_id.value.value = "";
      this.receive_date.value.value = new Date();
      this.shipping_date.value.value = new Date();
      this.isEntryMode = true;
    }
  },
};
</script>
